<div class="overview-page">
  <app-workspace-hub-nav></app-workspace-hub-nav>
  <section class="overview-hero">
    <div>
      <p class="overview-kicker">Enterprise workspace</p>
      <h1>Teams overview</h1>
      <p>Live operational, membership, and workspace signals from the capabilities Flow Studio provides today.</p>
    </div>
    <app-workspace-identity [activeId]="this.workspaceId()"></app-workspace-identity>
  </section>

  @if (this.contextState() === 'loading') { <section class="overview-state">Loading workspace overview…</section> }
  @if (this.contextState() === 'noStorage') { <section class="overview-state overview-state--warning">Workspace storage must be provisioned before Teams data can be displayed.</section> }
  @if (this.contextState() === 'noLicense') { <section class="overview-state overview-state--error">A Flow Studio Teams licence is required.</section> }

  @if (this.contextState() === 'ready') {
    @if (this.sourceWarning()) { <div class="overview-warning">{{ this.sourceWarning() }} Other available workspace data is still shown.</div> }
    <section class="overview-stats">
      <article><span>Monitored flows</span><strong>{{ this.monitoredFlows().length | number }} / {{ this.flows().length | number }}</strong><small>Current flow inventory</small></article>
      <article><span>Runs · last 7 days</span><strong>{{ this.runs().length | number }}</strong><small>{{ this.failedRuns() | number }} failed runs</small></article>
      <article><span>Run success</span><strong>{{ this.successRate() === null ? '—' : ((this.successRate() || 0) | percent:'1.1-1') }}</strong><small>Completed succeeded and failed runs</small></article>
      <article><span>Teams licences</span><strong>{{ this.teamsLicensedMembers() | number }} / {{ (this.workspaceSeatLimit() ?? '—') }}</strong><small>{{ this.members().length | number }} workspace member records</small></article>
    </section>

    <section class="overview-grid">
      <article class="overview-card">
        <div class="overview-card-head"><div><p class="overview-card-kicker">Operations</p><h2>Monitoring health</h2></div><a routerLink="/teams/monitor">View Monitor</a></div>
        <div class="overview-detail-grid">
          <div><span>Monitored</span><strong>{{ this.monitoredFlows().length | number }}</strong></div>
          <div><span>Succeeded runs</span><strong>{{ this.successfulRuns() | number }}</strong></div>
          <div><span>Failed runs</span><strong>{{ this.failedRuns() | number }}</strong></div>
        </div>
        @if (!this.flows().length) { <p class="overview-empty">No flow inventory is available yet. Complete a workspace scan to populate monitoring.</p> }
      </article>

      <article class="overview-card">
        <div class="overview-card-head"><div><p class="overview-card-kicker">People</p><h2>Membership and licences</h2></div><a routerLink="/teams/members">Manage Members</a></div>
        <div class="overview-detail-grid">
          <div><span>Members</span><strong>{{ this.members().length | number }}</strong></div>
          <div><span>Teams assigned</span><strong>{{ this.teamsLicensedMembers() | number }}</strong></div>
          <div><span>Available seats</span><strong>{{ this.workspaceSeatLimit() === null ? '—' : ((this.workspaceSeatLimit() || 0) - this.teamsLicensedMembers()) }}</strong></div>
        </div>
      </article>

      <article class="overview-card">
        <div class="overview-card-head"><div><p class="overview-card-kicker">Inventory</p><h2>Latest workspace scan</h2></div><a routerLink="/teams/workspace">Open Workspace</a></div>
        <strong class="overview-feature-value">{{ this.latestScanLabel() }}</strong>
        <p>{{ this.latestScanCoverage() }}</p>
      </article>

      <article class="overview-card">
        <div class="overview-card-head"><div><p class="overview-card-kicker">Connections</p><h2>Connected accounts</h2></div><a routerLink="/teams/workspace">Manage Connections</a></div>
        <strong class="overview-feature-value">{{ this.accounts().length | number }}</strong>
        <p>{{ this.accounts().length ? 'Delegated accounts available for workspace scanning and monitoring.' : 'No delegated Power Platform accounts are connected.' }}</p>
      </article>
    </section>
  }
</div>
